"use client";
import { ToastPosition, useToast } from "./Toast";

// Example usage component
export const ToastExample: React.FC = () => {
  const { showToast } = useToast();

  return (
    <div style={{ padding: "40px", background: "#0a0a0a", minHeight: "100vh" }}>
      <h1 style={{ color: "#fff", marginBottom: "24px" }}>Toast Examples</h1>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "12px",
          marginBottom: "32px",
        }}
      >
        <button
          onClick={() =>
            showToast("Success! Operation completed.", "success", "top-right")
          }
          style={{
            padding: "12px 24px",
            background: "#10b981",
            color: "#fff",
            borderWidth: "0",
            borderStyle: "none",
            borderColor: "transparent",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "600",
          }}
        >
          Show Success
        </button>

        <button
          onClick={() =>
            showToast("Error! Something went wrong.", "error", "top-center")
          }
          style={{
            padding: "12px 24px",
            background: "#ef4444",
            color: "#fff",
            borderWidth: "0",
            borderStyle: "none",
            borderColor: "transparent",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "600",
          }}
        >
          Show Error
        </button>

        <button
          onClick={() =>
            showToast(
              "Warning! Please check your input.",
              "warning",
              "bottom-right"
            )
          }
          style={{
            padding: "12px 24px",
            background: "#f59e0b",
            color: "#fff",
            borderWidth: "0",
            borderStyle: "none",
            borderColor: "transparent",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "600",
          }}
        >
          Show Warning
        </button>

        <button
          onClick={() =>
            showToast("Info: Here is some information.", "info", "bottom-left")
          }
          style={{
            padding: "12px 24px",
            background: "#3b82f6",
            color: "#fff",
            borderWidth: "0",
            borderStyle: "none",
            borderColor: "transparent",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "600",
          }}
        >
          Show Info
        </button>
      </div>

      <h2 style={{ color: "#fff", marginBottom: "16px" }}>Position Examples</h2>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
        {(
          [
            "top-left",
            "top-center",
            "top-right",
            "bottom-left",
            "bottom-center",
            "bottom-right",
          ] as ToastPosition[]
        ).map((position) => (
          <button
            key={position}
            onClick={() => showToast(`Toast at ${position}`, "info", position)}
            style={{
              padding: "12px 24px",
              background: "#2a2a2a",
              color: "#e5e5e5",
              borderWidth: "2px",
              borderStyle: "solid",
              borderColor: "#333",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: "600",
            }}
          >
            {position}
          </button>
        ))}
      </div>
    </div>
  );
};
